import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: 20,
  },
  closeButton: {
    position: 'absolute',
    right: 10,
    top: 10,
    color: "#000",
    "&:hover": {
      color: "#26bbed"
    }
  },
  dialogRoot: {
    borderRadius: 0,
    width: 580,
    background: "white"
  },
  heading: {
    fontSize: 20,
    fontFamily: 'Open Sans'
  }
})

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, className, ...other } = props
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h5" className={classes.heading}>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
})

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px 20px',
    borderTop: '1px solid #dadada'
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '24px 20px',
  },
}))(MuiDialogActions)

const CustomizedModal = withStyles(styles)(({
  open,
  maxWidth = "md",
  title = "Modal Title",
  children,
  handleClose,
  actionChildren,
  classes,
  className
}) => {
  return (
    <Dialog onClose={handleClose} open={open} maxWidth={maxWidth} fullWidth PaperProps={{
      classes: {
        rounded: className && className.dialogRoot ? className.dialogRoot : classes.dialogRoot
      }
    }}>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        {title}
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      {
        actionChildren &&
        <DialogActions>
          {actionChildren}
        </DialogActions>
      }
    </Dialog>
  )
})

export default CustomizedModal